import { signOut } from 'next-auth/react';
import { useRouter } from 'next/navigation';

export default function useAutenticacaoAcoes() {
  const router = useRouter();

  async function deslogar(callbackUrl = '/logar') {
    localStorage.removeItem('chippuPlace@AcessoAPPChippu');
    await signOut({ callbackUrl });
    router.refresh();
  }

  return { deslogar };
}
